import { unescape } from "lodash-es";

import { isDefined } from "../assert";

// Google returns `adr_address` as an hCard HTML string:
// `<span class="street-address">SN+ADDR</span>, <span class="locality">CITY</span>, ...`
// Pull one part out of it by hCard class name. Returns undefined when the part is not there,
// so callers can distinguish "Google didn't give us this" from an empty value.
export const extractAdrAddressPart = (
  adrAddress: string | undefined,
  className: string
): string | undefined => {
  try {
    const value = (adrAddress ?? "")
      .split(/<\/\w+>(,\s*)?/) // split by closing tag
      .filter(isDefined) // split() injects undefined wherever the optional comma group did not match
      .find((segment) => segment.includes(`class="${className}"`))
      ?.split(/<\w+[^>]*>/)?.[1]; // drop the opening tag
    return value ? unescape(value) : undefined;
  } catch {
    return undefined;
  }
};
